export default __webpack_public_path__ + "static/media/dashboard-icon.060ab9e2.svg";